import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading state for blog posts
 */
const BlogPostLoading = () => {

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-red-50 to-green-100 py-8">
      <div className="container mx-auto max-w-4xl px-4">
        {/* Hero Section Skeleton */}
        <Card className="mb-8 overflow-hidden border-2 border-green-200 shadow-lg">
          <div className="relative">
            <Skeleton className="h-64 w-full" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-6">
              <Skeleton className="h-8 w-3/4 bg-white/20 mb-2" />
              <Skeleton className="h-4 w-1/2 bg-white/20" />
            </div>
          </div>
        </Card>

        {/* Content Skeleton */}
        <Card className="border-2 border-red-200 shadow-lg">
          <CardContent className="p-8">
            {/* Checking for redirects message */}
            <div className="text-center mb-8 p-4 bg-green-50 rounded-lg border border-green-200">
              <div className="flex items-center justify-center space-x-2">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-green-600"></div>
                <p className="text-green-700 font-medium">Loading article...</p>
              </div>
            </div>
            
            <div className="space-y-6">
              <Skeleton className="h-6 w-full" />
              <Skeleton className="h-6 w-5/6" />
              <Skeleton className="h-6 w-4/5" />
              
              <div className="space-y-3 mt-8">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
              </div>
              
              <div className="mt-8">
                <Skeleton className="h-48 w-full rounded-lg" />
              </div>
              
              <div className="space-y-3 mt-8">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-5/6" />
                <Skeleton className="h-4 w-4/5" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default BlogPostLoading;
